module.exports = __webpack_public_path__ + "img/0008.8bb107b3.jpg";